module.exports = __webpack_public_path__ + "img/march.5171c160.svg";